<template>
  <PropertyDetailsCard>
    <template #title>Amenities</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyAmenitiesInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added any amenities yet"
      subtitle="List all amenities to showcase the full value of your rental"
      button-text="Add amenities"
      @button-clicked="showModal"
    />
    <PropertyAmenitiesModal ref="amenitiesModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyAmenitiesInfo,
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
} from '@tallo/property';

import PropertyAmenitiesModal from './property-amenities-modal.vue';

const amenitiesModalRef = ref<InstanceType<typeof PropertyAmenitiesModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.amenities));

function showModal() {
  amenitiesModalRef.value?.modalRef?.show();
}
</script>
